import React from 'react'

import { Col, Grid } from '../../../kiti/components/structure/Grid'
import BlockMarkerPlugin from '../_plugins/BlockMarkerPlugin'
import FontSizePlugin from '../_plugins/FontSizePlugin'
import ImagePlugin from '../_plugins/ImagePlugin'
import InterpolationPlugin from '../_plugins/InterpolationPlugin'
import Line from '../../../kiti/components/helpers/Line'
import LinkPlugin from '../_plugins/LinkPlugin'
import ListPlugin from '../_plugins/ListPlugin'
import MarkerPlugin from '../_plugins/MarkerPlugin'
import Panel from '../../../kiti/components/structure/Panel'
import QuotePlugin from '../_plugins/QuotePlugin'
import RawInterpolationPlugin from '../_plugins/RawInterpolationPlugin'
import Separator from '../../../kiti/components/helpers/Separator'
import SeparatorPlugin from '../_plugins/SeparatorPlugin'
import Sticky from '../../../kiti/components/helpers/Sticky'

const ControlBar = ({ interpolations }) => {
  return (
    <Sticky zIndex={10}>
      <Panel padding={0.8} radius={0} noBorder shadow="light4" bgColor="white" fixed>
        <Separator maxWidth={50} width="100%" margin="auto">
          <Grid gap={0.8} align="center">
            <FontSizePlugin.ToggleIcon name="h1" size={1.2} />
            <FontSizePlugin.ToggleIcon name="h2" size={1.2} />
            <FontSizePlugin.ToggleIcon name="h3" size={1.2} />

            <Col>
              <Line vertical height={0.6} color="light4" />
            </Col>

            <MarkerPlugin.ToggleIcon icon="RiBold" name="bold" size={1.2} />
            <MarkerPlugin.ToggleIcon icon="RiItalic" name="italic" size={1.2} />
            <MarkerPlugin.ToggleIcon icon="RiUnderline" name="underline" size={1.2} />

            <Col>
              <Line vertical height={0.6} color="light4" />
            </Col>

            <BlockMarkerPlugin.ToggleIcon icon="RiAlignLeft" name="align" value="left" size={1.2} />
            <BlockMarkerPlugin.ToggleIcon icon="RiAlignCenter" name="align" value="center" size={1.2} />
            <BlockMarkerPlugin.ToggleIcon icon="RiAlignRight" name="align" value="right" size={1.2} />

            <Col>
              <Line vertical height={0.6} color="light4" />
            </Col>

            <QuotePlugin.ToggleIcon size={1.2} />
            <ListPlugin.ToggleIcon name="list" size={1.2} />
            <ListPlugin.ToggleIcon name="numered_list" size={1.2} />
            <SeparatorPlugin.Icon size={1.2} />

            <Col>
              <Line vertical height={0.6} color="light4" />
            </Col>

            <LinkPlugin.ToggleIcon size={1.2} />
            <ImagePlugin.Icon size={1.2} />

            <Col>
              <Line vertical height={0.6} color="light4" />
            </Col>

            <RawInterpolationPlugin.ToggleIcon size={1.2} />

            <Col flex={1} />

            <InterpolationPlugin.Dropdown options={interpolations} />
          </Grid>

          <LinkPlugin.Menu />
          <RawInterpolationPlugin.Menu />
          <ImagePlugin.Menu />
        </Separator>
      </Panel>
    </Sticky>
  )
}

export default ControlBar
